import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Globals } from 'src/app/shared/globals/globals';

export interface RevisionSavePayload {
  enquiryNo: string;
  customerRequestDate: number;
}

@Component({
  selector: 'app-modal-revision',
  templateUrl: './modal-revision.component.html',
  styleUrl: './modal-revision.component.scss'
})
export class ModalRevisionComponent {

  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() enquiryNo!: string;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<RevisionSavePayload>();

  customerRequestDate: string | null = null;
  customerRequestDateTouched = false;
  currentStep: 1 | 2 = 1;
  maxDate: Date = new Date();

  constructor(public globals: Globals) {
  }

  ngOnInit(): void {
  }

  get isCustomerRequestDateValid(): boolean {
    if (!this.customerRequestDateTouched) {
      return true;
    }
    return !!this.customerRequestDate;
  }

  get isStepOne(): boolean {
    return this.currentStep === 1;
  }

  get isStepTwo(): boolean {
    return this.currentStep === 2;
  }

  onConfirmClick(): void {
    this.currentStep = 2;
    this.customerRequestDateTouched = false;
  }

  onBackClick(): void {
    this.currentStep = 1;
    this.customerRequestDate = null;
    this.customerRequestDateTouched = false;
  }

  onCustomerRequestDateChange(value: string): void {
    this.customerRequestDate = value ? value : null;
  }

  onCloseClick(): void {
    this.resetForm();
    this.onClose.emit();
  }

  onSaveClick(): void {
    this.customerRequestDateTouched = true;
    if (!this.customerRequestDate) {
      return;
    }
    this.onSave.emit({
      enquiryNo: this.enquiryNo,
      customerRequestDate: Number(this.customerRequestDate)
    });
    this.resetForm();
  }

  private resetForm(): void {
    this.customerRequestDate = null;
    this.customerRequestDateTouched = false;
    this.currentStep = 1;
  }

}
